import { AppConfig } from "../../../../shared/app-configs/app-config";
import { TCAppConfig } from "../../../../shared/app-configs/tc-app-configs";
import apiService from "../../../../shared/service/api-service";
import { useTransactionCertificateStore } from "../../../../store/transaction-certificates.store";

export const dtrackItService = {
    async getOrganicFarmStandards() {
        const queryParams = {
            query_param: TCAppConfig.GET_ORGANIC_FARM_CODE
        }
        const response = await apiService.get<any>(TCAppConfig.DTRACKIT_BASE_ENDPOINT_V4, queryParams)
        return response;
    },
// Additional v4 methods
    async getTCStatus() {
        const queryParams = {
            query_param: TCAppConfig.GET_TC_STATUS
        }
        const response = await apiService.get<any>(TCAppConfig.DTRACKIT_BASE_ENDPOINT_V4, queryParams)
        return response;
    },
    async getReturnTCStatus() {
        const queryParams = {
            query_param: TCAppConfig.GET_RET_TC_STATUS
        }
        const response = await apiService.get<any>(TCAppConfig.DTRACKIT_BASE_ENDPOINT_V4, queryParams)
        return response;
    },
    async getStandradLabelGrade() {
        const queryParams = {
            query_param: TCAppConfig.GET_STANDARD_LABEL_GRADE_V4
        }
        const response = await apiService.get<any>(TCAppConfig.DTRACKIT_BASE_ENDPOINT_V4, queryParams)
        return response;
    },


    async getProductCategory() {
        const queryParams = {
            query_param: TCAppConfig.GET_PRODUCT_CODE_V4
        }
        const response = await apiService.get<any>(TCAppConfig.DTRACKIT_BASE_ENDPOINT_V4, queryParams)
        return response;
    },

    async getProductDetailsCode() {
        const queryParams = {
            query_param: TCAppConfig.GET_PRODUCT_DETAIL_CODE_V4
        }
        const response = await apiService.get<any>(TCAppConfig.DTRACKIT_BASE_ENDPOINT_V4, queryParams)
        return response;
    },

    async getCountry() {
        const queryParams = {
            query_param: TCAppConfig.GET_COUNTRY_CODE_V4
        }
        const response = await apiService.get<any>(TCAppConfig.DTRACKIT_BASE_ENDPOINT_V4, queryParams)
        return response;
    },

    async getStateBasedonCountry(country: any) {
        // The v4 DTrackIt endpoint expects the country parameter in a bracketed
        // single-quoted list format like: ['IN'] (matching how scope-certificates passes it).
        // Accept either a plain country code (e.g. 'IN') or an already formatted string.
        let countryParam = country;
        try {
            if (country && typeof country === 'string') {
                // If it's a simple code without brackets, wrap it
                const trimmed = country.trim();
                if (!trimmed.startsWith('[')) {
                    countryParam = `[${[trimmed].map((c: any) => `'${c}'`)}]`;
                } else {
                    countryParam = trimmed;
                }
            }
        } catch (e) {
            // fallback to original value
            countryParam = country;
        }

        const queryParams = {
            query_param: TCAppConfig.GET_STATE_CODE_V4,
            country: countryParam,
        };
        const response = await apiService.get<any>(TCAppConfig.DTRACKIT_BASE_ENDPOINT_V4, queryParams);
        return response;
    },
    // v4: search state for Place of Issue using state_desc instead of country
    async getStatesByDescription(stateDesc: string) {
        const queryParams = {
            query_param: TCAppConfig.GET_STATE_CODE_V4,
            state_desc: stateDesc
        } as any
        const response = await apiService.get<any>(TCAppConfig.DTRACKIT_BASE_ENDPOINT_V4, queryParams)
        return response;
    },
    async getRawMaterialCodes(tcId?: string) {
        const queryParams: Record<string, any> = {
            query_param: TCAppConfig.GET_RAW_MATERIAL_CODE_V4
        };
        if (tcId) {
            queryParams.tcId = tcId;
        }
        const response = await apiService.get<any>(TCAppConfig.DTRACKIT_BASE_ENDPOINT_V4, queryParams);
        return response;
    },
    async getCBLicensingCodes() {
        const queryParams = {
            query_param: TCAppConfig.GET_CBLICENSING_CODE
        }
        const response = await apiService.get<any>(TCAppConfig.DTRACKIT_BASE_ENDPOINT_V4, queryParams)
        return response;
    },
    async getFacilityProcessCategoryCodes() {
        const queryParams = {
            query_param: TCAppConfig.GET_FACILITY_PROCESS_CATEGORY_CODE
        }
        const response = await apiService.get<any>(TCAppConfig.DTRACKIT_BASE_ENDPOINT_V4, queryParams)
        return response;
    },

    async getStandradLabelGradeOnBasisOfSelectedStandard(standard: string[]) {
        const queryParams = {
            standard: [...standard,"NA"],
        }
        const response = await apiService.get<any>(TCAppConfig.DTRACKIT_BASE_ENDPOINT_V4, queryParams)
        return response;
    },

    async getMetricsValues() {
        const queryParams = {
            query_param: TCAppConfig.GET_METRIC_CODES
        }
        const response = await apiService.get<any>(TCAppConfig.DTRACKIT_BASE_ENDPOINT_V4, queryParams)
        return response;
    },
    // New methods for Seller SC based filtering
    async getProductCategoryByTcId(tcId: string) {
        const queryParams = {
            query_param: TCAppConfig.GET_PRODUCT_CODE_V4,
            tcId: tcId
        }
        const response = await apiService.get<any>(TCAppConfig.GET_DTRACKIT_REF_CODE_V4, queryParams)
        return response;
    },
    async getProductDetailsCodeByTcId(tcId: string) {
        const queryParams = {
            query_param: TCAppConfig.GET_PRODUCT_DETAIL_CODE_V4,
            tcId: tcId
        }
        const response = await apiService.get<any>(TCAppConfig.GET_DTRACKIT_REF_CODE_V4, queryParams)
        return response;
    },
    async getSCProductClaimsCategory(scId: string) {
        const queryParams = {
            scId: scId
        }
        const response = await apiService.get<any>(TCAppConfig.GET_SC_PRODUCT_CLAIMS_CATEGORY_V4, queryParams)
        return response;
    }
}